import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { usePathSelector } from "@/context/PathSelectorContext";
import { useInquiryJourney } from "./useInquiryJourney";
import { StepShell, OVERLAY_MOTION, PANEL_MOTION } from "./StepShell";
import { SelectStep } from "./SelectStep";
import { QuestionStep } from "./QuestionStep";
import { DetailsStep } from "./DetailsStep";
import { DoneStep } from "./DoneStep";

const STEP_COMPONENTS = { select: SelectStep, questions: QuestionStep, details: DetailsStep, done: DoneStep };

export const PathSelectorModal = () => {
  const { open, initialPath, closeSelector } = usePathSelector();
  const journey = useInquiryJourney(open, initialPath);
  const Step = STEP_COMPONENTS[journey.step];
  const stepKey = journey.step === "questions" ? `q-${journey.currentQuestion?.id}` : journey.step;
  return (
    <AnimatePresence>
      {open && (
        <motion.div {...OVERLAY_MOTION}
          className="fixed inset-0 z-[100] flex items-stretch justify-center overflow-y-auto bg-slate-950/70 backdrop-blur-sm md:items-center md:p-6"
          onClick={closeSelector} data-testid="path-selector-modal">
          <motion.div {...PANEL_MOTION} className="relative w-full max-w-4xl bg-white md:rounded-3xl"
            onClick={(event) => event.stopPropagation()}>
            <button onClick={closeSelector} data-testid="path-selector-close" aria-label="Close"
              className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full border border-border bg-white text-slate-500 transition-colors hover:text-slate-900">
              <X className="h-5 w-5" />
            </button>
            <div className="p-6 md:p-12">
              <AnimatePresence mode="wait">
                <StepShell key={stepKey}><Step journey={journey} closeSelector={closeSelector} /></StepShell>
              </AnimatePresence>
            </div>
          </motion.div>
          <style>{`
            .scc-input { width:100%; border:1px solid hsl(214 32% 91%); border-radius:.75rem; background:#fff; padding:.75rem 1rem; font-size:.95rem; color:#0f172a; transition:border-color .2s ease, box-shadow .2s ease; }
            .scc-input:focus { outline:none; border-color:#2563eb; box-shadow:0 0 0 3px rgba(37,99,235,.15); }
          `}</style>
        </motion.div>
      )}
    </AnimatePresence>
  );
};